import clsx from 'clsx'
import React, { FC } from 'react'
import { useAuth } from '../../../../app/contexts/AuthProvider';
import { toAbsoluteUrl } from '../../../helpers'
// TODO: Descomentar
// import { HeaderUserMenu } from '../../../partials'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3', toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px';

const Topbar: FC = () => {
  const { usuario } = useAuth();

  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)} id='kt_header_user_menu_toggle'>
        <div
          className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          {
            usuario?.avatar && (
              <img style={{
                marginRight: '5px'
              }} src={toAbsoluteUrl(usuario?.avatar)} alt='metronic' />
            )
          }
          <span className="fw-bolder">{usuario?.nome}</span>
          <i style={{
            marginLeft: '5px'
          }} className="fas fa-arrow-down text-dark"></i>
        </div>
        {/* TODO: Descomentar */}
        {/* <HeaderUserMenu /> */}
      </div>
    </div>
  )
}

export { Topbar }
